import React from 'react';
import { Link } from 'react-router-dom';

import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';
import Container from 'react-bootstrap/Container';
import Dropdown from 'react-bootstrap/Dropdown';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebookSquare, faInstagramSquare, faYoutubeSquare, faTwitterSquare } from '@fortawesome/free-brands-svg-icons';
import { faEllipsisV } from '@fortawesome/free-solid-svg-icons';

import { SentaiLogoImage } from '../constants';

const Footer = () => {
    return (
        <Navbar id="footer" variant="dark" bg="black" fixed="bottom">
            <Container>
                <MobileLinks />
                <SentaiLink />
                <SocialLinks />
                <DesktopLinks />
                <Nav.Item>© Copyright 2021</Nav.Item>
            </Container>
        </Navbar>
    );
}

const SentaiLink = () => (
    <Navbar.Brand id="SentaiLogo" className="display-1" href="//www.sentaifilmworks.com" target="_black">
        <img
            src={SentaiLogoImage}
            width="60"
            height="15"
            className="d-inline-block align-top opacity-50"
            alt="React Bootstrap logo"
        />
    </Navbar.Brand>
);

const SocialLinks = () => (
    <Nav>
        <Nav.Item>
            <Nav.Link href="//www.facebook.com/sentaifilmworks" target="_blank">
                <FontAwesomeIcon icon={faFacebookSquare} />
            </Nav.Link>
        </Nav.Item>
        <Nav.Item>
            <Nav.Link href="//www.twitter.com/sentaifilmworks" target="_blank">
                <FontAwesomeIcon icon={faTwitterSquare} />
            </Nav.Link>
        </Nav.Item>
        <Nav.Item>
            <Nav.Link href="//www.instagram.com/sentaifilmworks" target="_blank">
                <FontAwesomeIcon icon={faInstagramSquare} />
            </Nav.Link>
        </Nav.Item>
        <Nav.Item>
            <Nav.Link href="//www.youtube.com/user/SentaiFilmworksAnime" target="_blank">
                <FontAwesomeIcon icon={faYoutubeSquare} />
            </Nav.Link>
        </Nav.Item>
    </Nav>
);

const DesktopLinks = () => (
    <Nav className="ml-auto d-none d-sm-flex">
        <Nav.Link to="/accessibility" as={Link}>Accessibility</Nav.Link>
        <Nav.Link to="/about" as={Link}>About</Nav.Link>
        <Nav.Link to="/privacy-policy" as={Link}>Privacy Policy</Nav.Link>
    </Nav>
);

const MobileLinks = () => (
    <Dropdown className="d-sm-none" drop="up" >
        <Dropdown.Toggle as="div">
            <FontAwesomeIcon icon={faEllipsisV} />
        </Dropdown.Toggle>

        <Dropdown.Menu>
            <Dropdown.Item to="/accessibility" as={Link}>Accessibility</Dropdown.Item>
            <Dropdown.Item to="/about" as={Link}>About</Dropdown.Item>
            <Dropdown.Item to="/privacy-policy" as={Link}>Privacy Policy</Dropdown.Item>
        </Dropdown.Menu>
    </Dropdown>
);

export default Footer;